import { checkHttpStatusAuthCheck } from '../../../../../actions/utilAction';
import {
  actionCreator,
  API_URL,
  BILLING_CLAIMS,
  RENDER_AUTO_COMPLETE_MUI, // Material UI Autocomplete
  BillingActionTypes,
  checkHttpStatus,
  createSearchUrlForCustomAPI,
  downloadFilesOnAPICall,
  //downloadFilesOnAPICallForEDI,
  EDI837_BATCHCLAIM_API,
  EDI837_SINGLECLAIM_API,
  SUBMITCLAIMSFORNONEDI_API,
  GET_CLAIMS_WITH_SERVICE_LINES_FORPAYER_API,
  GET_MASTERDATABYNAME,
  GET_PATIENT,
  GET_PATIENT_GUARANTOR,
  GET_PROCESSED_CLAIMS_API,
  GET_UNMAPPED_CLAIMS_API,
  GET_SERVICE_LOCATIONS_API,
  EDI837_BATCH_CLAIM_SECONDARY_API,
  GET_SERVICELINE_DETAILS_API,
  EDI837_SECONDARY_API,
  PAPER_CLAIM_API_SECONDARY,
  PARSEEDI835_FROMCLEARINGHOUSE,
  EDI837_BATCHRESUBMITCLAIM_API,
  jsonApiHeader,
  PAPER_CLAIM_API,
  POST_APPLY_PAYMENT_API,
  RESUBMIT_CLAIM_API,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
  GET_PAYER_SERVICECODE_BY_ID,
  GET_PAYER_SERVICE_CODES_API,
  DELETE_CLAIM,
  BATCHPAPER_CLAIM_API,
  BATCHPAPER_CLAIM_FORSECONDARYPAYER_API,
  POST_CLAIM_INTERNAL_NOTES_API,
  GET_CLAIM_INTERNAL_NOTES_API,
  DELETE_CLAIM_INTERNAL_NOTES_API,
  CHANGE_CLAIM_STATUS,
  SAVE_NOTES_BULK_API,
  GET_EDI835_FILE_API,
  downloaduploadedDocumentsOnAPICall,
  UPDATEBATCHCLAIMSRENDERINGPROVIDER_CLAIM_API,
  PARSEEDI835_FROMCLEARINGHOUSE_MASTERACCOUNT,
  EVV_BATCHCLAIM_API,
  DOWNLOADSECONDARY837_BATCH_CLAIM_API,
  DOWNLOADRESUBMITEDI837_BATCH_CLAIM_API,
  DOWNLOADEDI837_BATCH_CLAIM_API,
  PARSEEVVRESPONSE_FROMTELLUS,
  GET_PROCESSED_EVVCLAIMS_API,
  GET_EVV_FILE_API,
  DELETE_BATCH_APPLIED_PAYMENTS_API,
  DOWNLOADEDIENCOUNTERS_BATCH_CLAIM_API,
  PARSEEDI999_FROMCLEARINGHOUSE,
  GET_OAANDPAYERRESPONSE_CLAIMS_API,
  GET_OAACKNOWLEDGEMENT_CLAIMS_API,
  UPDATEBATCHRATEFORSERVICECODES_CLAIM_API,
  POST_BATCH_PAYMENT_DETAILS_API,
  GET_PAYMENT_DETAILS_API,
  POST_PAYMENT_DETAILS_API,
  BULK_UPDATE_WRITE_OFF_DATE_API,
  GET_LEDGER_DETAILS_API,
  GET_REASONCODES,
  PATCH_UPDATEBATCHREASONCODE,
  POST_ADDUPDATEREASONCODE,
  DELETE_REASONCODE,
  CHANGE_EVV_STATUS,
  GETEVVCLIENTNAME,
  GETALLSECONDARYPAYER,
} from '../constants/ApiConstants';
import moment from 'moment';

export const getLedgerDetails = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_ledgerDetails.REQUEST));
    fetch(`${GET_LEDGER_DETAILS_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(BillingActionTypes.get_ledgerDetails.SUCCESS, response));
      }).catch(function(error) {
        console.log('error getLedgerDetails...', error);
      });
  };
};

export const getMasterData = (masterData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_master_data.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify(masterData),
      // body: JSON.stringify({ 'masterdata': 'masterservicecode' }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function (response) {
        dispatch(actionCreator(BillingActionTypes.get_master_data.SUCCESS, response));
      })
      .catch(function (error) {

      });
  };
};

export const getClaimMasterData = (masterData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_claim_master_data.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify(masterData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(BillingActionTypes.get_claim_master_data.SUCCESS, response));
      })
      .catch(function (error) {
        console.log('getClaimMasterData...', error)
      });
  };
};

export const getPatient = (searchObj) => {
  let query_params = `?locationIds=${searchObj.locationIds}&permissionKey=''&isActiveCheckRequired=${searchObj.isActiveCheckRequired}&isActiveClientsOnly=${searchObj.isActiveClientsOnly}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_patient.REQUEST));
    fetch(`${GET_PATIENT}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response..................', response);
        dispatch(actionCreator(BillingActionTypes.get_patient.SUCCESS, response));
      })
      .catch(function (error) {

      });
  };
};
export const getPatientGuarantor = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_patient_guarantor.REQUEST));
    fetch(`${GET_PATIENT_GUARANTOR}?patientId=${patientId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response..................', response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(BillingActionTypes.get_patient_guarantor.SUCCESS, response));
        } else {
          dispatch(actionCreator(BillingActionTypes.get_patient_guarantor.SUCCESS, null));
        }
      })
      .catch(function (error) {

      });
  };
};
export const getClaims = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_claims.REQUEST));

    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${BILLING_CLAIMS}/GetClaims${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(BillingActionTypes.get_claims.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};

export const getAllSecondaryPayer = (claimId) => {
  console.log(claimId);
  
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.getAllSecondaryPayer.REQUEST));

    fetch(`${GETALLSECONDARYPAYER}?ClaimIds=${claimId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(BillingActionTypes.getAllSecondaryPayer.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};

export const getAllClaimsWithServiceLines = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_AllClaimsWithServiceLines.REQUEST));

    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${BILLING_CLAIMS}/GetAllClaimsWithServiceLines${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response......', response);
        dispatch(actionCreator(BillingActionTypes.get_AllClaimsWithServiceLines.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};
export const getClaimHistory = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_claim_history.REQUEST));
    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${BILLING_CLAIMS}/GetClaimHistory${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response......', response);
        dispatch(actionCreator(BillingActionTypes.get_claim_history.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};


export const getClaimDetailsById = (claimId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_ClaimDetails_ByClaimId.REQUEST));

    fetch(`${BILLING_CLAIMS}/GetClaimDetailsById?claimId=${claimId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(BillingActionTypes.get_ClaimDetails_ByClaimId.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};

export const getClaimServiceLines = (claimId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_ClaimServiceLines_ByClaimId.REQUEST));

    fetch(`${BILLING_CLAIMS}/GetClaimServiceLines?claimId=${claimId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(BillingActionTypes.get_ClaimServiceLines_ByClaimId.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};

// get service codes for the patient payer..
export const getPatientPayerServiceCodes = (searchObj) => {
  // let dateTime = null;
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_all_payer_cpt_codes_by_payer.REQUEST));
    fetch(`${GET_PAYER_SERVICE_CODES_API}?patientId=${searchObj.patientId}&PayerPreference=${searchObj.payerPreference}&date=${searchObj.dateTime}&payerId=${searchObj.payerId}&patientInsuranceId=${searchObj.patientInsuranceId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(BillingActionTypes.get_all_payer_cpt_codes_by_payer.SUCCESS, response));
        } else {
          dispatch(actionCreator(BillingActionTypes.get_all_payer_cpt_codes_by_payer.SUCCESS, null));
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};


// export const GetPayerServiceCodesByPayerId = (patientInsuranceId) => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(BillingActionTypes.get_all_payer_cpt_codes_by_payer.REQUEST));
//     fetch(`${GET_ALL_PAYER_SERVICE_CODES}?payerID=${patientInsuranceId}`, {
//       method: 'get',
//       headers: jsonApiHeader(getState().login.access_token, 'application/json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         dispatch(actionCreator(BillingActionTypes.get_all_payer_cpt_codes_by_payer.SUCCESS, response));
//       })
//       .catch(function(error) {
//         console.log('error payer ...', error);
//       });
//   };
// };

export const GetPayerServiceCodeById = (payerServiceCodeId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_payer_servicecode_by_Id.REQUEST));
    // let query_params = createSearchUrlForCustomAPI(searchObj);    
    fetch(`${GET_PAYER_SERVICECODE_BY_ID}?payerServiceCodeId=${payerServiceCodeId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response............',response)
        dispatch(actionCreator(BillingActionTypes.get_payer_servicecode_by_Id.SUCCESS, response));
      })
      .catch(function (error) {
        console.log('error payer ...', error);
      });
  };
};

// save SERVICE Codes For Claim
export const saveServiceCodesForClaim = (formData, claimId) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.Post_ServiceCode_ForClaim.REQUEST));
    let postData = JSON.stringify(formData);
    // let Method = formData.id > 0 ? 'PATCH' : 'post'
    fetch(`${BILLING_CLAIMS}/SaveClaimServiceLine?claimId=${claimId}`, {
      method: 'PATCH',
      body: postData,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {
          dispatch(actionCreator(BillingActionTypes.Post_ServiceCode_ForClaim.SUCCESS, response));

          if (response && response.message && response.statusCode === 403)
            showErrorMessage(response.message);
          else 
            showSuccessMessage(response.message);
          // dispatch(getClaimServiceLines(claimId));
          // let searchObj = {
          //   sort_fields: 'id',
          //   sort_order: 'asc',
          //   pageNumber: 1,
          // };
          // dispatch(getAllClaimsWithServiceLines(searchObj));
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const deleteServiceCodeFromClaim = (serviceLineId, claimId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.delete_ServiceCode_FromClaim.REQUEST));
    fetch(`${BILLING_CLAIMS}/DeleteClaimServiceLine?serviceLineId=${serviceLineId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.delete_ServiceCode_FromClaim.SUCCESS, response));
        } else if (response.statusCode === 401) {
          showWarningMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }

        // dispatch(getClaimServiceLines(claimId));
        // let searchObj = {
        //   sort_fields: 'claimid',
        //   sort_order: 'desc',
        //   pageNumber: 1,
        //   claimStatusId: 1,
        // };
        // dispatch(getAllClaimsWithServiceLines(searchObj));
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};


// save SERVICE Codes For Claim
export const updateClaimDetails = (formData) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.update_Claim_Detials.REQUEST));
    let postData = JSON.stringify(formData);
    // console.log('JSON.stringify(formData).......',JSON.stringify(formData))
    fetch(`${BILLING_CLAIMS}/UpdateClaimDetails`, {
      method: 'PATCH',
      body: postData,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {

          dispatch(actionCreator(BillingActionTypes.update_Claim_Detials.SUCCESS, response));
          // console.log('response.......',response)

          if (response && response.message)
            showSuccessMessage(response.message);
          else
            showSuccessMessage('Claim has been updated successfully');

          // let searchObj = {
          //   sort_fields: 'id',
          //   sort_order: 'asc',
          //   pageNumber: 1,
          // };
          // dispatch(getAllClaimsWithServiceLines(searchObj));
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

// save SERVICE Codes For Claim
export const updateClaimServiceLineDetails = (formData) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.update_Claim_Detials.REQUEST));
    let postData = JSON.stringify(formData);
    // console.log('JSON.stringify(formData).......',JSON.stringify(formData))
    fetch(`${BILLING_CLAIMS}/UpdateClaimServiceLineDetails`, {
      method: 'PATCH',
      body: postData,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {

          dispatch(actionCreator(BillingActionTypes.update_Claim_Detials.SUCCESS, response));
          // console.log('response.......',response)

          if (response && response.message)
            showSuccessMessage(response.message);
          else
            showSuccessMessage('Claim service line has been updated successfully');

          // let searchObj = {
          //   sort_fields: 'id',
          //   sort_order: 'asc',
          //   pageNumber: 1,
          // };
          // dispatch(getAllClaimsWithServiceLines(searchObj));
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const updateClaimServiceLineModifier = (formData, modifierName) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.update_Claim_Detials.REQUEST));
    let postData = JSON.stringify(formData);
    // console.log('JSON.stringify(formData).......',JSON.stringify(formData))
    fetch(`${BILLING_CLAIMS}/UpdateClaimServiceLineModifier?modifierName=`+ modifierName, {
      method: 'PATCH',
      body: postData,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {

          dispatch(actionCreator(BillingActionTypes.update_Claim_Detials.SUCCESS, response));
          // console.log('response.......',response)

          if (response && response.message)
            showSuccessMessage(response.message);
          else
            showSuccessMessage('Claim service line has been updated successfully');

          // let searchObj = {
          //   sort_fields: 'id',
          //   sort_order: 'asc',
          //   pageNumber: 1,
          // };
          // dispatch(getAllClaimsWithServiceLines(searchObj));
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

// save SERVICE Codes For Claim
export const updateClaimServiceLineNotesDetails = (formData) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.update_Claim_Detials.REQUEST));
    let postData = JSON.stringify(formData);
    // console.log('JSON.stringify(formData).......',JSON.stringify(formData))
    fetch(`${BILLING_CLAIMS}/UpdateClaimServiceLineNoteDetails`, {
      method: 'PATCH',
      body: postData,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {

          dispatch(actionCreator(BillingActionTypes.update_Claim_Detials.SUCCESS, response));
          // console.log('response.......',response)

          if (response && response.message)
            showSuccessMessage(response.message);
          else
            showSuccessMessage('Claim service line has been updated successfully');

          // let searchObj = {
          //   sort_fields: 'id',
          //   sort_order: 'asc',
          //   pageNumber: 1,
          // };
          // dispatch(getAllClaimsWithServiceLines(searchObj));
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const getPatientEncounterDetails = (patientAppointmentId,encounterId) => {
  return (dispatch, getState) => {
    // dispatch(actionCreator(BillingActionTypes.get_PatientEncounterDetails_ByEncounterId.REQUEST));
    fetch(`${API_URL}/patient-encounter/GetPatientEncounterDetails/${patientAppointmentId}/${encounterId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(BillingActionTypes.get_PatientEncounterDetails_ByEncounterId.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};


export const getPayerByPatientId = (patientId, key) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_PayerByPatientId.REQUEST));
    fetch(`${API_URL}/GetPayerByPatient?PatientID=${patientId}&Key=${key}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(BillingActionTypes.get_PayerByPatientId.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};

/**
 * @desc To download paper claim for secondary payer.
 * @param {*} claimId
 * @param {*} payerId
 * @param {*} organizationId
 */
export const SubmitClaim = (claimId, payerId, markSubmitted, printFormat) => {
  return (dispatch, getState) => {
    // console.log('claimID-----', claimId);
    // const showPDF = (blob) => {
    //   // It is necessary to create a new blob object with mime-type explicitly set
    //   // otherwise only Chrome works like it should
    //   var newBlob = new Blob([blob], { type: 'application/pdf' });
    //   // IE doesn't allow using a blob object directly as link href
    //   // instead it is necessary to use msSaveOrOpenBlob
    //   if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //     window.navigator.msSaveOrOpenBlob(newBlob);
    //     return;
    //   }
    //   // For other browsers:
    //   // Create a link pointing to the ObjectURL containing the blob.
    //   const data = window.URL.createObjectURL(newBlob);
    //   var link = document.createElement('a');
    //   link.href = data;
    //   // link.download = 'file.pdf';
    //   link.click();
    //   window.open(data, '_blank');
    //   // setTimeout(function() {
    //   //   // For Firefox it is necessary to delay revoking the ObjectURL
    //   //   window.URL.revokeObjectURL(data);
    //   // }, 100);
    // };

    dispatch(actionCreator(BillingActionTypes.get_SubmitClaim.REQUEST));
    let apiURL = `${PAPER_CLAIM_API}?claimId=${claimId}&patientInsuranceId=${payerId}&markSubmitted=${markSubmitted}&printFormat=${printFormat}`;
    // console.log(apiURL)
    fetch(apiURL, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/pdf'),
    }).then(function (response) {
      return response.blob();
    }).then(function (blob) {
      downloadFilesOnAPICall(blob, claimId);
      dispatch(actionCreator(BillingActionTypes.get_SubmitClaim.SUCCESS, true));
    });
  };
};
export const SubmitClaim_Secondary = (claimId, payerId, printFormat) => {
  return (dispatch, getState) => {

    dispatch(actionCreator(BillingActionTypes.get_Paper_Claim_secondary.REQUEST));
    let apiURL = `${PAPER_CLAIM_API_SECONDARY}?claimId=${claimId}&patientInsuranceId=${payerId}&printFormat=${printFormat}`;
    // console.log(apiURL)
    fetch(apiURL, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/pdf'),
    }).then(function (response) {
      return response.blob();
    }).then(function (blob) {
      downloadFilesOnAPICall(blob, claimId);
      dispatch(actionCreator(BillingActionTypes.get_Paper_Claim_secondary.SUCCESS, true));
    });
  };
};
export const SubmitEDIClaimForSecondary = (claimId, patientInsuranceId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_EDI837_secondary.REQUEST));
    let apiURL = `${EDI837_SECONDARY_API}?claimId=${claimId}&patientInsuranceId=${patientInsuranceId}`;
    fetch(apiURL, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        // console.log('response.................', response);
        dispatch(actionCreator(BillingActionTypes.get_EDI837_secondary.SUCCESS, response));
      });
  };
};
export const ReSubmitClaim = (claimId, patientInsuranceId, resubmissionReason, payerControlReferenceNumber) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_ResubmitClaim.REQUEST));
    let apiURL = `${RESUBMIT_CLAIM_API}?claimId=${claimId}&patientInsuranceId=${patientInsuranceId}&resubmissionReason=${resubmissionReason}&payerControlReferenceNumber=${payerControlReferenceNumber}`;
    // console.log('apiURL............',apiURL)
    fetch(apiURL, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        // console.log('response.................', response);
        dispatch(actionCreator(BillingActionTypes.get_ResubmitClaim.SUCCESS, response));
      });
    // .then((r) => r.blob())
    // .then(downloadFilesOnAPICall) // showPDF
    // .then((blob) => dispatch(actionCreator(BillingActionTypes.get_ResubmitClaim.SUCCESS, true)));
  };
};
export const getAllClaimsWithServiceLinesForPayer = (searchObj) => {
  let query_params = `?payerIds=${searchObj.PayerIds || ''}&patientIds=${searchObj.PatientIds || ''}&tags=${searchObj.patientTags || ''}&fromDate=${searchObj.fromDate || ''}&toDate=${searchObj.toDate || ''}&locationId=${searchObj.currentLocationId}&claimBalanceStatus=${searchObj.claimBalanceStatus || ''}&sortColumn=${searchObj.sortColumn || ''}&sortOrder=${searchObj.sortOrder || ''}&isExcludeTag=${searchObj.isExcludeTag || false}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_AllClaimsWithServiceLinesForPayer.REQUEST));
    fetch(`${GET_CLAIMS_WITH_SERVICE_LINES_FORPAYER_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response.................', response)
        dispatch(actionCreator(BillingActionTypes.get_AllClaimsWithServiceLinesForPayer.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};
export const getProcessedClaims = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  // console.log(query_params)
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_processed_claim.REQUEST));
    fetch(`${GET_PROCESSED_CLAIMS_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(BillingActionTypes.get_processed_claim.SUCCESS, response));
      })
      .catch(function (error) {
        console.log('Error', error);
      });
  };
};

export const getUnmappedClaims = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  // console.log(query_params)
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_unmapped_claim.REQUEST));
    fetch(`${GET_UNMAPPED_CLAIMS_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(BillingActionTypes.get_unmapped_claim.SUCCESS, response));
      })
      .catch(function (error) {
        console.log('Error', error);
      });
  };
};

export const submitApplyPayments = (formData) => {
  let postData = JSON.stringify(formData);
  // console.log('formData..................', formData)
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.post_apply_payment.REQUEST));
    fetch(`${POST_APPLY_PAYMENT_API}`, {
      method: 'POST',
      body: postData,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        //  console.log('response..................', response);

        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(BillingActionTypes.post_apply_payment.SUCCESS, response));
      })
      .catch(function (error) {
        showErrorMessage('Oops, something went wrong, please try later.');
        dispatch(actionCreator(BillingActionTypes.post_apply_payment.FAILURE));

        // errorHandler(error);
      });
  };
};


export const getServiceLocations = (locationId, patientId) => {
  let currentDate = moment().format('YYYY-MM-DD');
  let query_params = `?locationId=${locationId || null}&patientId=${patientId || null}&startDate=${currentDate}&endDate=${currentDate}&patientInsuranceId=null`;
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_patient_serviceLocations.REQUEST));
    fetch(`${GET_SERVICE_LOCATIONS_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        dispatch(actionCreator(BillingActionTypes.get_patient_serviceLocations.SUCCESS, response));
      }).catch(function (error) {
        console.log('getServiceLocations...', error);
      });
  };
};

export const getServiceLineDetails = (claimId, serviceLineId) => {
  let query_params = `?claimId=${claimId || null}&serviceLineId=${serviceLineId || null}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_claimServiceLineDetails.REQUEST));
    fetch(`${GET_SERVICELINE_DETAILS_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        dispatch(actionCreator(BillingActionTypes.get_claimServiceLineDetails.SUCCESS, response));
      }).catch(function (error) {
        console.log('getServiceLineDetails...', error);
      });
  };
};


// export const SubmitEDIClaim = (claimId, payerId) => {
//   let query_params = `?claimId=${claimId || null}&patientInsuranceId=${payerId || null}`;
//   return (dispatch, getState) => {
//     dispatch(actionCreator(BillingActionTypes.get_SubmitClaim_EDI837.REQUEST));
//     let apiURL = `${EDI837_SINGLECLAIM_API}${query_params}`;
//     fetch(apiURL, {
//       method: 'GET',
//       headers: jsonApiHeader(getState().login.access_token, 'text/plain'),
//     })
//       .then((r) => r.blob())
//       .then(downloadFilesOnAPICallForEDI) // showPDF
//       .then((blob) => dispatch(actionCreator(BillingActionTypes.get_SubmitClaim_EDI837.SUCCESS, true)));
//   };
// };

// export const SubmitBatchEDIClaim = (claimIds) => {
//   let query_params = `?claimIds=${claimIds || ''}`;
//   return (dispatch, getState) => {
//     dispatch(actionCreator(BillingActionTypes.get_SubmitBatchClaim_EDI837.REQUEST));
//     fetch(`${EDI837_BATCHCLAIM_API}${query_params}`, {
//       method: 'GET',
//       headers: jsonApiHeader(getState().login.access_token, 'text/plain'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         // console.log('response..................', response);
//         if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
//           showSuccessMessage(response.message);
//         } else {
//           showErrorMessage(response.message);
//         }
//         dispatch(actionCreator(BillingActionTypes.get_SubmitBatchClaim_EDI837.SUCCESS, response));
//       })
//       .catch(function(error) {
//         showErrorMessage('Oops, something went wrong, please try later.');
//         dispatch(actionCreator(BillingActionTypes.get_SubmitBatchClaim_EDI837.FAILURE));
//       // errorHandler(error);
//       });
//   };
// };

// export const SubmitBatchEDIClaimForSecondary = (claimIds) => {
//   let query_params = `?claimIds=${claimIds || ''}`;
//   return (dispatch, getState) => {
//     dispatch(actionCreator(BillingActionTypes.get_EDI837_Batch_Claim_secondary.REQUEST));
//     fetch(`${EDI837_BATCH_CLAIM_SECONDARY_API}${query_params}`, {
//       method: 'GET',
//       headers: jsonApiHeader(getState().login.access_token, 'text/plain'),
//     })
//       .then(checkHttpStatus)
//       .then(function (response) {
//         // console.log('response..................', response);
//         if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
//           showSuccessMessage(response.message);
//         } else {
//           showErrorMessage(response.message);
//         }
//         dispatch(actionCreator(BillingActionTypes.get_EDI837_Batch_Claim_secondary.SUCCESS, response));
//       })
//       .catch(function (error) {
//         showErrorMessage('Oops, something went wrong, please try later.');
//         dispatch(actionCreator(BillingActionTypes.get_EDI837_Batch_Claim_secondary.FAILURE));
//         // errorHandler(error);
//       });
//   };
// };

export const SubmitEDIClaim = (claimId, payerId) => {
  let query_params = `?claimId=${claimId || null}&patientInsuranceId=${payerId || null}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_SubmitClaim_EDI837.REQUEST));
    fetch(`${EDI837_SINGLECLAIM_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response..................', response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(BillingActionTypes.get_SubmitClaim_EDI837.SUCCESS, response));
      })
      .catch(function (error) {
        console.log('error', error)
        showErrorMessage('Oops, something went wrong, please try later.');
        dispatch(actionCreator(BillingActionTypes.get_SubmitClaim_EDI837.FAILURE));

        // errorHandler(error);
      });
  };
};

export const SubmitBatchEDIClaim = (claimIds) => {
  let query_params = `?claimIds=${claimIds || ''}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_SubmitBatchClaim_EDI837.REQUEST));
    fetch(`${EDI837_BATCHCLAIM_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response..................', response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(BillingActionTypes.get_SubmitBatchClaim_EDI837.SUCCESS, response));
      })
      .catch(function (error) {
        showErrorMessage('Oops, something went wrong, please try later.');
        dispatch(actionCreator(BillingActionTypes.get_SubmitBatchClaim_EDI837.FAILURE));

        // errorHandler(error);
      });
  };
};


export const SubmitBatchEVVClaim = (claimIds, claimStatusId) => {
  let query_params = `?claimIds=${claimIds || ''}&claimStatusId=${claimStatusId}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_SubmitBatchClaim_EVV.REQUEST));
    fetch(`${EVV_BATCHCLAIM_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response..................', response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204 && response.statusCode !== 206) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(BillingActionTypes.get_SubmitBatchClaim_EVV.SUCCESS, response));
      })
      .catch(function (error) {
        showErrorMessage('Oops, something went wrong, please try later.');
        dispatch(actionCreator(BillingActionTypes.get_SubmitBatchClaim_EVV.FAILURE));

        // errorHandler(error);
      });
  };
};

export const SubmitClaimsForNonEDIPayers = (claimIds) => {
  let query_params = `?claimIds=${claimIds || ''}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_SubmitClaimsForNonEDI.REQUEST));
    fetch(`${SUBMITCLAIMSFORNONEDI_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response..................', response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(BillingActionTypes.get_SubmitClaimsForNonEDI.SUCCESS, response));
      })
      .catch(function (error) {
        showErrorMessage('Oops, something went wrong, please try later.');
        dispatch(actionCreator(BillingActionTypes.get_SubmitClaimsForNonEDI.FAILURE));

        // errorHandler(error);
      });
  };
};

export const ResubmitBatchEDIClaim = (claimIds) => {
  let query_params = `?claimIds=${claimIds || ''}`;
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_ResubmitBatchClaim_EDI837.REQUEST));
    fetch(`${EDI837_BATCHRESUBMITCLAIM_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response..................', response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(BillingActionTypes.get_ResubmitBatchClaim_EDI837.SUCCESS, response));
      })
      .catch(function (error) {
        showErrorMessage('Oops, something went wrong, please try later.');
        dispatch(actionCreator(BillingActionTypes.get_ResubmitBatchClaim_EDI837.FAILURE));

        // errorHandler(error);
      });
  };
};

export const ParseEDI835FromClearingHouse = () => {
  // console.log('Parse EDI835 From Clearing House Calling Start')
  return (dispatch, getState) => {
    fetch(`${PARSEEDI835_FROMCLEARINGHOUSE}`, {
      method: 'Get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('Parse EDI835 From Clearing House Calling End')
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  };
};

export const ParseEDI835FromClearingHouseFromPage = () => {
  // console.log('Parse EDI835 From Clearing House Calling Start')
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_ParseEDI835_FromClearingHouse.REQUEST));
    fetch(`${PARSEEDI835_FROMCLEARINGHOUSE}`, {
      method: 'Get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
        } else if (response.statusCode === 404) {
          showWarningMessage(response.message);          
        }  else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(BillingActionTypes.get_ParseEDI835_FromClearingHouse.SUCCESS, response));
        // console.log('Parse EDI835 From Clearing House Calling End')
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  };
};

export const ParseEDI835FromClearingHouseFromMasterAccount = () => {
  // console.log('Parse EDI835 From Clearing House Calling Start')
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_ParseEDI835_FromClearingHouse_MasterAccount.REQUEST));
    fetch(`${PARSEEDI835_FROMCLEARINGHOUSE_MASTERACCOUNT}`, {
      method: 'Get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
        } else if (response.statusCode === 404) {
          showWarningMessage(response.message);          
        }  else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(BillingActionTypes.get_ParseEDI835_FromClearingHouse_MasterAccount.SUCCESS, response));
        // console.log('Parse EDI835 From Clearing House Calling End')
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  };
};


export const getPatientAutocomplete = (encounterId) => {
  return (dispatch, getState) => {
    // dispatch(actionCreator(BillingActionTypes.get_PatientEncounterDetails_ByEncounterId.REQUEST));
    fetch(`${API_URL}/patient-encounter/GetPatientEncounterDetails/0/${encounterId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(BillingActionTypes.get_PatientEncounterDetails_ByEncounterId.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};

// Material UI Autocomplete
export const getNameAndInsuranceAutoComplete = (tableName, columnName, searchText) => {
  let query_params = `?tableName=${tableName}&columnName=${columnName}&searchText=${searchText}`;
  return (dispatch, getState) => {
    fetch(`${RENDER_AUTO_COMPLETE_MUI}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(BillingActionTypes.get_autocomplete_mui.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};


export const deleteClaim = (claimId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.delete_Claim.REQUEST));
    fetch(`${DELETE_CLAIM}/${claimId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(BillingActionTypes.delete_Claim.SUCCESS, response));
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const BatchReSubmitClaim = (postData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.post_ResubmitBatchClaim_EDI837.REQUEST));
    fetch(`${EDI837_BATCHRESUBMITCLAIM_API}`, {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.post_ResubmitBatchClaim_EDI837.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.post_ResubmitBatchClaim_EDI837.SUCCESS, null));          
        }
      })
      .catch(function (error) {
        console.log('error BatchReSubmitClaim', error);
      });
  };
};

export const SubmitBatchEDIClaimForSecondary = (postData) => {  
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_EDI837_Batch_Claim_secondary.REQUEST));
    fetch(`${EDI837_BATCH_CLAIM_SECONDARY_API}`, {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.get_EDI837_Batch_Claim_secondary.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.get_EDI837_Batch_Claim_secondary.SUCCESS, null));          
        }
      })
      .catch(function (error) {
        console.log('error BatchSubmitSecondaryClaim', error);
      });
  };
};

export const SubmitBatchPaperClaimsForNonEDIPayers = (claimIds, payerPreference, markSubmitted, printFormat, actionScreen) => {
  return (dispatch, getState) => {
   
    dispatch(actionCreator(BillingActionTypes.get_SubmitBatchClaim.REQUEST));
    let apiURL = `${BATCHPAPER_CLAIM_API}?claimIds=${claimIds}&payerPreference=${payerPreference}&markSubmitted=${markSubmitted}&printFormat=${printFormat}&actionScreen=${actionScreen}`;
    // console.log(apiURL)
    fetch(apiURL, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/pdf'),
    }).then(function(response) {
      return response.blob();
    }).then(function(blob) {
      downloadFilesOnAPICall(blob, "Batch");
      dispatch(actionCreator(BillingActionTypes.get_SubmitBatchClaim.SUCCESS, true));
    });
  };
};

export const SubmitBatchPaperClaimsForNonEDISecondaryPayers = (claimIds, payerPreference, printFormat) => {
  return (dispatch, getState) => {
   
    dispatch(actionCreator(BillingActionTypes.get_SubmitBatchClaim_SecondaryPayer.REQUEST));
    let apiURL = `${BATCHPAPER_CLAIM_FORSECONDARYPAYER_API}?claimIds=${claimIds}&payerPreference=${payerPreference}&printFormat=${printFormat}`;
    // console.log(apiURL)
    fetch(apiURL, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/pdf'),
    }).then(function(response) {
      return response.blob();
    }).then(function(blob) {
      downloadFilesOnAPICall(blob, "Batch");
      dispatch(actionCreator(BillingActionTypes.get_SubmitBatchClaim_SecondaryPayer.SUCCESS, true));
    });
  };
};

// save Update Claim Internal Notes
export const saveClaimInternalNote = (formData, claimId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.Post_Claim_Internal_Notes.REQUEST));
    let apiURL = `${POST_CLAIM_INTERNAL_NOTES_API}`;
    fetch(`${apiURL}`, {
      method: 'POST',      
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formData)
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {
          dispatch(actionCreator(BillingActionTypes.Post_Claim_Internal_Notes.SUCCESS, response));
          // console.log('response.......',response)
          if (response && response.message){
            showSuccessMessage(response.message);            
            let searchObj = {
                sort_fields: '',
                sort_order:  '',
                contain_filters: { claimId: claimId, SearchText: null },
                pageNumber: 1,
            };      
            dispatch(getAllClaimInternalNotes(searchObj, claimId));            
          }
          else
            showSuccessMessage('Claim notes has been updated successfully');       
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const getAllClaimInternalNotes = (searchObj, claimId) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);  
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.Get_Claim_Internal_Notes.REQUEST));
    fetch(`${GET_CLAIM_INTERNAL_NOTES_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response.................', response)
        dispatch(actionCreator(BillingActionTypes.Get_Claim_Internal_Notes.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};

export const deleteClaimInternalNote = (noteId, claimId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.Delete_Claim_Internal_Notes.REQUEST));
    let apiURL = `${DELETE_CLAIM_INTERNAL_NOTES_API}?noteId=${noteId}`;
    fetch(`${apiURL}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {
          if (response && response.statusCode === 200){
          showSuccessMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.Delete_Claim_Internal_Notes.SUCCESS, response));
            let searchObj = {
              sort_fields: '',
              sort_order:  '',
              contain_filters: { claimId: claimId, SearchText: null },
              pageNumber: 1,
          };      
          dispatch(getAllClaimInternalNotes(searchObj, claimId));
          }
          else{
            showSuccessMessage(response.message);
            dispatch(actionCreator(BillingActionTypes.Delete_Claim_Internal_Notes.SUCCESS, null));
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};


export const changeClaimsStatus = (claimIds, claimStatusId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.change_Claim_Status.REQUEST));
    let apiURL = `${CHANGE_CLAIM_STATUS}?claimIds=${claimIds}&statusId=${claimStatusId}`;
    fetch(`${apiURL}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {
          if (response && response.statusCode === 200){
          showSuccessMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.change_Claim_Status.SUCCESS, response));
          }
          else{
            showSuccessMessage(response.message);
            dispatch(actionCreator(BillingActionTypes.change_Claim_Status.SUCCESS, null));
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const changeEVVClaimsStatus = (claimIds, claimStatusId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.change_evv_Status.REQUEST));
    let apiURL = `${CHANGE_EVV_STATUS}?claimIds=${claimIds}&statusId=${claimStatusId}`;
    fetch(`${apiURL}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {
          if (response && response.statusCode === 200){
          showSuccessMessage(response.message);
        dispatch(actionCreator(BillingActionTypes.change_evv_Status.SUCCESS, response));
          }
          else{
            showSuccessMessage(response.message);
            dispatch(actionCreator(BillingActionTypes.change_evv_Status.SUCCESS, null));
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};



export const SaveBulkNoteAction = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.save_NotesBulk.REQUEST));
    fetch(`${SAVE_NOTES_BULK_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formData)
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.save_NotesBulk.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.save_NotesBulk.SUCCESS, null));          
        }
      })
      .catch(function (error) {
        console.log('error save_NotesBulk', error);
      });
  };
};
      
export const BulkUpdateWriteOffDateAction = (claimIds, date,searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.bulkUpdateWriteOffDate.REQUEST));
    fetch(`${BULK_UPDATE_WRITE_OFF_DATE_API}?claimIds=${claimIds}&closeOrWriteOffDate=${date}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    }) 
      .then(checkHttpStatus)
      .then(function (response) { 
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.bulkUpdateWriteOffDate.SUCCESS, response));
          dispatch(getLedgerDetails(searchObj))
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.bulkUpdateWriteOffDate.SUCCESS, null));          
        }
      })
      .catch(function (error) {
        console.log('error BulkUpdateWriteOffDateAction', error);
      });
  };
};


// Document Download
export const EDI835Download = (docId, fileName) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_edi835_file.REQUEST));
    fetch(`${GET_EDI835_FILE_API}?id=${docId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    }).then(function(response) {
      dispatch(actionCreator(BillingActionTypes.get_edi835_file.SUCCESS));
      return response.blob();
    }).then(function(blob) {
      downloaduploadedDocumentsOnAPICall(blob, fileName);
    });
  };
};


export const UpdateBatchClaimsRenderingProvider = (claimIds, renderingProviderId) => {
  return (dispatch, getState) => {
   
    dispatch(actionCreator(BillingActionTypes.patch_UpdateBatchCLaimRenderingProvider_Claim.REQUEST));
    let apiURL = `${UPDATEBATCHCLAIMSRENDERINGPROVIDER_CLAIM_API}?claimIds=${claimIds}&renderingProviderId=${renderingProviderId}`;
    // console.log(apiURL)
    fetch(apiURL, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/pdf'),
    })
    .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.patch_UpdateBatchCLaimRenderingProvider_Claim.SUCCESS, response));
          //dispatch(getLedgerDetails(searchObj))
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.patch_UpdateBatchCLaimRenderingProvider_Claim.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error update_batch_claims_payment_status...', error);
      });
  };
};

// download Batch EDI 837
export const downloadBatchEDI837 = (claimIds) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_download_batch_EDI.REQUEST));
    fetch(`${DOWNLOADEDI837_BATCH_CLAIM_API}?claimIds=${claimIds}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    }).then(function(response) {
      dispatch(actionCreator(BillingActionTypes.get_download_batch_EDI.SUCCESS));
      return response.blob();
    }).then(function(blob) {
      let fileName = "EDI_PRIMARY_PAYER_" + moment().format('YYYYMMDDHHMMSS') + ".X12";
      downloaduploadedDocumentsOnAPICall(blob, fileName);
    });
  };
};


// download RESUBMIT Batch EDI 837
export const downloadResubmitBatchEDI837 = (postData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.post_ResubmitBatchClaim_EDI837.REQUEST));
    fetch(`${DOWNLOADRESUBMITEDI837_BATCH_CLAIM_API}`, {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    }).then(function(response) {
      dispatch(actionCreator(BillingActionTypes.post_ResubmitBatchClaim_EDI837.SUCCESS));
      return response.blob();
    }).then(function(blob) {
      let fileName = "EDI_PRIMARY_PAYER_RESUBMIT_" + moment().format('YYYYMMDDHHMMSS') + ".X12";
      downloaduploadedDocumentsOnAPICall(blob, fileName);
    });
  };
};


// download RESUBMIT Batch EDI 837
export const downloadBatchEDIClaimForSecondary = (postData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_EDI837_Batch_Claim_secondary.REQUEST));
    fetch(`${DOWNLOADSECONDARY837_BATCH_CLAIM_API}`, {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    }).then(function(response) {
      dispatch(actionCreator(BillingActionTypes.get_EDI837_Batch_Claim_secondary.SUCCESS));
      return response.blob();
    }).then(function(blob) {
      let fileName = "EDI_SECONDARY_PAYER_" + moment().format('YYYYMMDDHHMMSS') + ".X12";
      downloaduploadedDocumentsOnAPICall(blob, fileName);
    });
  };
};


export const getAllEVVClaimsWithServiceLines = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_AllClaimsWithServiceLines.REQUEST));

    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${BILLING_CLAIMS}/GetAllEVVClaimsWithServiceLines${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response......', response);
        dispatch(actionCreator(BillingActionTypes.get_AllClaimsWithServiceLines.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};

// export const ParseEVVReponseFromTellus = () => {
//   // console.log('Parse EDI835 From Clearing House Calling Start')
//   return (dispatch, getState) => {
//     fetch(`${PARSEEVVRESPONSE_FROMTELLUS}`, {
//       method: 'Get',
//       headers: jsonApiHeader(getState().login.access_token, 'application/json'),
//     })
//       .then(checkHttpStatus)
//       .then(function (response) {
//         // console.log('Parse EDI835 From Clearing House Calling End')
//       })
//       .catch(function (error) {
//         console.log('error: ', error);
//       });
//   };
// };

export const ParseEVVReponseFromTellus = () => {
  // console.log('Parse EDI835 From Clearing House Calling Start')
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_ParseEVVResponse_FromTellus.REQUEST));
    fetch(`${PARSEEVVRESPONSE_FROMTELLUS}`, {
      method: 'Get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
        } else if (response.statusCode === 404) {
          showWarningMessage(response.message);          
        }  else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(BillingActionTypes.get_ParseEVVResponse_FromTellus.SUCCESS, response));
        // console.log('Parse EDI835 From Clearing House Calling End')
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  };
};


export const getProcessedEVVClaims = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  // console.log(query_params)
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_processed_evvclaim.REQUEST));
    fetch(`${GET_PROCESSED_EVVCLAIMS_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(BillingActionTypes.get_processed_evvclaim.SUCCESS, response));
      })
      .catch(function (error) {
        console.log('Error', error);
      });
  };
};


// Document Download
export const EVVFileDownload = (docId, fileName) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_evv_file.REQUEST));
    fetch(`${GET_EVV_FILE_API}?id=${docId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    }).then(function(response) {
      dispatch(actionCreator(BillingActionTypes.get_evv_file.SUCCESS));
      return response.blob();
    }).then(function(blob) {
      downloaduploadedDocumentsOnAPICall(blob, fileName);
    });
  };
};

export const getAppliedPaymentsDetails = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_AppliedPaymentDetails.REQUEST));

    let query_params = createSearchUrlForCustomAPI(searchObj);
    fetch(`${BILLING_CLAIMS}/GetAppliedPaymentsDetails${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        // console.log('response......', response);
        dispatch(actionCreator(BillingActionTypes.get_AppliedPaymentDetails.SUCCESS, response));
      })
      .catch(function (error) {
        // errorHandler(error);
      });
  };
};

export const DeleteBatchAppliedPayments = (paymentIds) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.delete_BatchAppliedPayments.REQUEST));
    fetch(`${DELETE_BATCH_APPLIED_PAYMENTS_API}?paymentIds=${paymentIds}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.delete_BatchAppliedPayments.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.delete_BatchAppliedPayments.SUCCESS, null));          
        }
      })
      .catch(function (error) {
        console.log('error delete_BatchAppliedPayments', error);
      });
  };
};


export const downloadBatchEDIEncountersClaims = (postData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_download_batch_EDI.REQUEST));
    fetch(`${DOWNLOADEDIENCOUNTERS_BATCH_CLAIM_API}`, {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    }).then(function(response) {
      dispatch(actionCreator(BillingActionTypes.get_download_batch_EDI.SUCCESS));
      return response.blob();
    }).then(function(blob) {
      let fileName = "EDI_ENCOUNTER_CLAIMS_" + moment().format('YYYYMMDDHHMMSS') + ".X12";
      downloaduploadedDocumentsOnAPICall(blob, fileName);
    });
  };
};


export const ParseEDI999FromClearingHouseFromPage = () => {
  // console.log('Parse EDI835 From Clearing House Calling Start')
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_ParseEDI999_FromClearingHouse.REQUEST));
    fetch(`${PARSEEDI999_FROMCLEARINGHOUSE}`, {
      method: 'Get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
        } else if (response.statusCode === 404) {
          showWarningMessage(response.message);          
        }  else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(BillingActionTypes.get_ParseEDI999_FromClearingHouse.SUCCESS, response));
        // console.log('Parse EDI835 From Clearing House Calling End')
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  };
};


export const getOAAcknowledgement = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  // console.log(query_params)
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_oaacknowledgement_claim.REQUEST));
    fetch(`${GET_OAACKNOWLEDGEMENT_CLAIMS_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(BillingActionTypes.get_oaacknowledgement_claim.SUCCESS, response));
      })
      .catch(function (error) {
        console.log('Error', error);
      });
  };
};

export const getOAandPayerResponseClaims = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  // console.log(query_params)
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_oaandpayerresponse_claim.REQUEST));
    fetch(`${GET_OAANDPAYERRESPONSE_CLAIMS_API}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        dispatch(actionCreator(BillingActionTypes.get_oaandpayerresponse_claim.SUCCESS, response));
      })
      .catch(function (error) {
        console.log('Error', error);
      });
  };
};


export const UpdateBatchRateForServiceCodes = (claimIds, serviceCode, modifier1, modifier2, modifier3, modifier4, rate) => {
  return (dispatch, getState) => {
   
    dispatch(actionCreator(BillingActionTypes.patch_UpdateBatchRateForServiceCodes_Claim.REQUEST));
    let apiURL = `${UPDATEBATCHRATEFORSERVICECODES_CLAIM_API}?claimIds=${claimIds}&serviceCode=${serviceCode}&modifier1=${modifier1}&modifier2=${modifier2}&modifier3=${modifier3}&modifier4=${modifier4}&rate=${rate}`;
    // console.log(apiURL)
    fetch(apiURL, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/pdf'),
    })
    .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.patch_UpdateBatchRateForServiceCodes_Claim.SUCCESS, response));
          //dispatch(getLedgerDetails(searchObj))
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.patch_UpdateBatchRateForServiceCodes_Claim.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error update_batch_claims_payment_status...', error);
      });
  };
};


export const saveBatchPaymentDetails = (formData) => {
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.post_batchPaymentDetails.REQUEST));
    fetch(`${POST_BATCH_PAYMENT_DETAILS_API}`, {
      method: 'post',
      body: postData,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(BillingActionTypes.post_batchPaymentDetails.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error saveBatchPaymentDetails...', error);
      });
  };
};

export const getPaymentDetails = (paymentDetailId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_paymentDetails.REQUEST));
    fetch(`${GET_PAYMENT_DETAILS_API}?paymentDetailId=${paymentDetailId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(BillingActionTypes.get_paymentDetails.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getPaymentDetails...', error);
      });
  };
};

export const savePaymentDetails = (formData) => {
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.post_paymentDetails.REQUEST));
    fetch(`${POST_PAYMENT_DETAILS_API}`, {
      method: 'post',
      body: postData,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(BillingActionTypes.post_paymentDetails.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error savePaymentDetails...', error);
      });
  };
};

export const getReasonCodes = (ClaimIds) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.get_reasonCodes.REQUEST));
    fetch(`${GET_REASONCODES}?ClaimIds=${ClaimIds}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(BillingActionTypes.get_reasonCodes.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getReasonCode...', error);
      });
  };
};

export const saveBatchUpdateReasonCode = (ClaimIds, reasonCode, note, ReasonCodeId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.patch_updateBatchReasonCode.REQUEST));  
    fetch(`${PATCH_UPDATEBATCHREASONCODE}?ClaimIds=${ClaimIds}&reasonCode=${reasonCode}&note=${note || ''}&ReasonCodeId=${ReasonCodeId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response) {
          dispatch(actionCreator(BillingActionTypes.patch_updateBatchReasonCode.SUCCESS, response));

          if (response && response.message && response.statusCode === 403)
            showErrorMessage(response.message);
          else 
            showSuccessMessage(response.message);
        }
      })
      .catch(function (error) {
        console.log("error saveBatchReasonCode....",error);
      });
  };
};

export const saveReasonCodeDetails = (formData) => {
  let postData = JSON.stringify(formData)
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.post_addUpdateReasonCode.REQUEST));  
    fetch(`${POST_ADDUPDATEREASONCODE}`, {
      method: 'POST',
      body: postData,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
        } else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(BillingActionTypes.post_addUpdateReasonCode.SUCCESS, response));
      })
      .catch(function (error) {
        console.log("error saveReasonCode....",error);
      });
  };
};

export const deleteReasonCode = (ClaimId,visitChangesId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.delete_reasonCode.REQUEST));
    fetch(`${DELETE_REASONCODE}?visitChangesId=${visitChangesId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.delete_reasonCode.SUCCESS, response));
          dispatch(getReasonCodes(ClaimId));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(BillingActionTypes.delete_reasonCode.SUCCESS, null));          
        }
      })
      .catch(function (error) {
        console.log('error delete_ReasonCode', error);
      });
  };
};


export const getIscalledFromERAMouleFlag = (claimID)=>{
   return (dispatch)=>{
      dispatch(actionCreator(BillingActionTypes.get_Iscalled_FromERAMoule_Flag.SUCCESS,claimID))
     }
}

export const getEVVClientName = () => {
  return (dispatch, getState) => {
    dispatch(actionCreator(BillingActionTypes.getEVVClientName.REQUEST));
    fetch(`${GETEVVCLIENTNAME}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(BillingActionTypes.getEVVClientName.SUCCESS, response));
      }).catch(function(error) {
        console.log('error getLedgerDetails...', error);
      });
  };
};


// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/actions/ManageClaimActions.js